// src/views/Clientes/ActualizacionLimiteDeCredito/EliminarLimiteCredito.jsx
import React from "react";
import { FaTrashAlt } from "react-icons/fa";
import apiRoutes from "../../../api/apiRoutes";
import { appFetchJson } from "../../../utils/http";

export default function EliminarLimiteCredito({
  initial,
  onVolver = () => {},
  onEliminar = () => {},   // el padre cierra modal + refresca
}) {
  const [removing, setRemoving] = React.useState(false);

  const idSafe = initial?.id ?? "(sin id)";
  const clienteSafe = initial?.clienteNombre ?? "(sin cliente)";

  // ESC para cerrar el modal (solo si no está procesando)
  React.useEffect(() => {
    const onKey = (e) => {
      if (e.key === "Escape" && !removing) {
        e.preventDefault();
        onVolver();
      }
    };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [removing, onVolver]);

  const handleDelete = async () => {
    if (!initial?.id) {
      // error simple si no hay ID
      if (window.overlay?.open) {
        window.overlay.open({
          mode: "error",
          title: "Error al eliminar",
          message: "Solicitud no encontrada.",
        });
      }
      return;
    }

    setRemoving(true);

    try {
      await appFetchJson(
        apiRoutes.limiteCredito.delete(initial.id),
        { method: "DELETE" },
        {
          showLoading: true,
          showSuccess: true,
          showError: true,   // ← antes showNotify

          loadingTitle: "Eliminando solicitud…",
          loadingMessage: "Por favor, espere sin cerrar ni recargar la página.",

          successTitle: "Operación realizada",
          successMessage: "La solicitud fue eliminada correctamente.",

          onSuccessClose: () => {
            setRemoving(false);
            onEliminar?.();
          },
        }
      );
    } catch (e) {
      console.error("Error eliminando solicitud:", e);
      // El overlay de error ya lo maneja appFetchJson vía notify + listener
      setRemoving(false);
    }
  };

  return (
    <div className="page w-full max-w-2xl">
      <div className="mb-4 flex items-center gap-3">
        <h2 className="page-title m-0">Eliminar Solicitud</h2>
      </div>

      <div className="rounded-md border border-gray-200 bg-white px-4 py-5">
        <div className="space-y-3">
          <p className="text-gray-800">
            Estás a punto de eliminar esta solicitud. Esta acción es permanente.
          </p>

          <div className="rounded border bg-gray-50 px-4 py-3 text-sm">
            <div className="flex items-center gap-2">
              <span className="text-gray-600 min-w-28">ID Solicitud:</span>
              <span className="font-semibold">{idSafe}</span>
            </div>

            <div className="flex items-center gap-2 mt-1">
              <span className="text-gray-600 min-w-28">Cliente:</span>
              <span className="font-semibold">{clienteSafe}</span>
            </div>
          </div>

          <div className="flex items-center justify-end gap-2 pt-2">
            <button
              type="button"
              className="btn-fil"
              onClick={onVolver}
              disabled={removing}
            >
              Cancelar
            </button>

            <button
              type="button"
              className="btn-fil inline-flex items-center gap-2"
              onClick={handleDelete}
              disabled={removing}
            >
              <FaTrashAlt />
              {removing ? "Eliminando…" : "Eliminar"}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
